const NavTabs = props => (
  <ul className='nav-tabs'>
    { props.tabs.map(x =>
      <li
        key={x}
        className={`nav-tab${props.selected === x.toLowerCase() ? '-selected' : ''}`}
        onClick={() => props.onClick(x.toLowerCase())}>
        { x }
      </li>
    ) }
  </ul>
)

export default NavTabs
